import { render, staticRenderFns } from "./WfirmaReportGenerator.vue?vue&type=template&id=aed5d808"
import script from "./WfirmaReportGenerator.vue?vue&type=script&lang=js"
export * from "./WfirmaReportGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports